"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectStructure = exports.selectPwhCList = exports.selectPwhCByHtgSys = exports.selectHxList = exports.selectHasData = exports.selectEquipment = exports.selectDevicesForChartRequestByKey = exports.selectBuildings = exports.selectAlarmItemByChartId = exports.selectActiveGroup = exports.selectActiveBuilding = void 0;
var _constants = require("../../utils/constants");
const selectBuildings = _ref => {
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref;
  return (devices === null || devices === void 0 ? void 0 : devices.data.buildings) || [];
};
exports.selectBuildings = selectBuildings;
const selectPwhCList = _ref2 => {
  var _devices$data$activeS;
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref2;
  return (devices === null || devices === void 0 || (_devices$data$activeS = devices.data.activeStructure) === null || _devices$data$activeS === void 0 || (_devices$data$activeS = _devices$data$activeS.byHtgSys) === null || _devices$data$activeS === void 0 ? void 0 : _devices$data$activeS.PwhC) || {};
};
exports.selectPwhCList = selectPwhCList;
const selectPwhCByHtgSys = _ref3 => {
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref3;
  return (devices === null || devices === void 0 ? void 0 : devices.data.allPwhCByHtgSys) || {};
};
exports.selectPwhCByHtgSys = selectPwhCByHtgSys;
const selectHxList = _ref4 => {
  var _devices$data$activeS2;
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref4;
  return (devices === null || devices === void 0 || (_devices$data$activeS2 = devices.data.activeStructure) === null || _devices$data$activeS2 === void 0 || (_devices$data$activeS2 = _devices$data$activeS2.byHtgSys) === null || _devices$data$activeS2 === void 0 ? void 0 : _devices$data$activeS2.HtgHx) || {};
};
exports.selectHxList = selectHxList;
const selectStructure = _ref5 => {
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref5;
  return (devices === null || devices === void 0 ? void 0 : devices.data.structure) || {};
};
exports.selectStructure = selectStructure;
const selectEquipment = _ref6 => {
  let {
    equipmentTypeKey,
    activeGroup
  } = _ref6;
  return _ref7 => {
    var _ref8;
    let {
      [_constants.packageKey]: {
        devices
      } = {}
    } = _ref7;
    return ((_ref8 = (devices === null || devices === void 0 ? void 0 : devices.data.structure) || {}) === null || _ref8 === void 0 || (_ref8 = _ref8[equipmentTypeKey]) === null || _ref8 === void 0 ? void 0 : _ref8[activeGroup]) || null;
  };
};
exports.selectEquipment = selectEquipment;
const selectActiveBuilding = _ref9 => {
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref9;
  return (devices === null || devices === void 0 ? void 0 : devices.data.activeBuilding) || null;
};
exports.selectActiveBuilding = selectActiveBuilding;
const selectActiveGroup = chartId => _ref10 => {
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref10;
  return (devices === null || devices === void 0 ? void 0 : devices.data.activeGroupByChartId[chartId]) || null;
};
exports.selectActiveGroup = selectActiveGroup;
const selectDevicesForChartRequestByKey = _ref11 => {
  let {
    equipmentKey,
    chartId
  } = _ref11;
  return _ref12 => {
    let {
      [_constants.packageKey]: {
        devices
      } = {}
    } = _ref12;
    return (devices === null || devices === void 0 ? void 0 : devices.data.devicesForChartRequest[equipmentKey][chartId]) || {};
  };
};
exports.selectDevicesForChartRequestByKey = selectDevicesForChartRequestByKey;
const selectHasData = _ref13 => {
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref13;
  return (devices === null || devices === void 0 ? void 0 : devices.data.hasData) || false;
};
exports.selectHasData = selectHasData;
const selectAlarmItemByChartId = chartId => _ref14 => {
  let {
    [_constants.packageKey]: {
      devices
    } = {}
  } = _ref14;
  return ((devices === null || devices === void 0 ? void 0 : devices.alarmItem) || {})[chartId] || null;
};
exports.selectAlarmItemByChartId = selectAlarmItemByChartId;